import React from 'react';
import {
    VertModal,
    Typography
} from '@vertem-core/vertice-ds';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';

const UserTermsModal = ({ isOpen, onClose }) => {

    return (
        <VertModal
            width={'40%'}
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => onClose()}
            className="modal-rules-bill-payment"
        >

            <Row gutter={[16, 16]}>

                <Col
                    span={24}
                    className='container-user-terms-main'>

                    <Typography.Text className='user-terms-text'>
                        Termo de uso
                    </Typography.Text>
                </Col>

                <Col span={24} className='container-term-span container-user-terms-sub'>

                    <span>
                        Você pode pagar contas de água, gás, luz e telefone através da empresa parceira.
                    </span>
                    <span>
                        Os pagamentos podem ser feitos de segunda à sexta, das 8h às 18h (horário de Brasília).
                    </span>
                    <span>
                        Pagamentos feitos em dias não úteis serão processados no próximo dia útil.
                    </span>
                    <span>
                        É cobrada uma taxa de 10% em cima do valor do boleto.
                    </span>
                    <span>
                        Não é possível cancelar o pagamento de uma conta depois que você finalizar o resgate. A informação já terá sido enviada à instituição financeira correspondente.
                    </span>
                    <span>
                        Contas de concessionárias são boletos emitidos por empresas de água, gás, luz, telefone e outros serviços em geral.
                    </span>

                </Col>

                <Col
                    span={24}
                    className='container-user-terms-important-message-main'>

                    <Typography.Text className='user-terms-important-message-text'>
                        Importante
                    </Typography.Text>
                </Col>

                <Col span={24} className='container-term-span container-user-terms-important-message-sub'>

                    <span>
                        Mantenha seus dados cadastrais atualizados.
                    </span>
                    <span>
                        Só é possível pagar boletos que possuam código de barras.
                    </span>
                    <span>
                        É de sua responsabilidade a digitação correta do código de barras.
                    </span>
                    <span>
                        Você só consegue pagar contas até 2 dias antes do vencimento. Um dia antes ou no dia do vencimento já não é mais possível.
                    </span>
                    <span>
                        O processo de pagamento não quita débitos futuros.
                    </span>
                    <span>
                        Algumas concessionárias não permitem o pagamento com pontos. Se for o caso da sua conta, mostraremos uma mensagem informando que o pagamento foi negado.
                    </span>
                    <span>
                        Caberá à você, em qualquer operação de pagamento, verificar com a concessionária a quitação de sua conta antes da data de seu vencimento.
                    </span>
                    <span>
                        Se por algum outro motivo não for possível finalizar o de pagamento da conta, mesmo após a confirmação de pagamento, a quantidade de pontos utilizada na operação será estornada para conta a sua conta. Enviaremos um e-mail informando a situação. Caso tenha dúvidas, clique aqui.
                    </span>

                </Col>

            </Row>

        </VertModal>
    );
};

export default UserTermsModal;
